import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const recalculateUserSaldo = async (
  userId,
  employerBusinessId,
  activeEmployerInfo
) => {
  const apiPath = `work-time-saldo/user/${userId}/recalculate-total-saldo-information`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { employerBusinessId },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);
  return response.data;
};
